import React from 'react'
import { makeStyles, tokens } from '@fluentui/react-components'
import { DraggableModal } from './DraggableModal'
import TextOutput from '../inputs/TextOutput'

const useStyles = makeStyles({
   bodyWrapper: {
      display: 'flex',
      flexDirection: 'column',
      gap: tokens.spacingVerticalXL,
   },
})

export type ReadOnlyField = {
   label: string
   value?: string
}

type ReadOnlyModalProps = {
   open: boolean
   title: React.ReactNode
   fields: ReadOnlyField[]
   children?: React.ReactNode
   onClose: () => void
}

// View-only variant of the annual calendar's modal: the same DraggableModal shell, but without
// form controls and without an action row - the close cross in the header is the only control.
// Both the overview's activities and its risks render through this so they stay identical.
export const ReadOnlyModal = ({ open, title, fields, children, onClose }: ReadOnlyModalProps) => {
   const classes = useStyles()

   return (
      <DraggableModal title={title} open={open} onClose={onClose}>
         <div className={classes.bodyWrapper}>
            {fields.map((field) => (
               <TextOutput key={field.label} label={field.label} text={field.value} />
            ))}
            {children}
         </div>
      </DraggableModal>
   )
}
